import { render, staticRenderFns } from "./MonitorCA3.vue?vue&type=template&id=3c8b778e&scoped=true"
import script from "./MonitorCA3.vue?vue&type=script&lang=js"
export * from "./MonitorCA3.vue?vue&type=script&lang=js"
import style0 from "./MonitorCA3.vue?vue&type=style&index=0&id=3c8b778e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b778e",
  null
  
)

export default component.exports